export default __webpack_public_path__ + "static/media/smallColoredLogoAprobank.4bf1d63c.svg";